import { Component, type ReactNode } from "react";

interface State {
  error: Error | null;
}

interface Props {
  children: ReactNode;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack?: string | null }): void {
    // eslint-disable-next-line no-console
    console.error("[mobai-web] render error:", error, info.componentStack);
  }

  private reset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="mx-auto max-w-lg px-4 py-16 text-center">
        <h1 className="text-lg font-semibold text-rose-300 mb-2">Something broke</h1>
        <p className="text-sm text-surface-400 mb-4">{this.state.error.message}</p>
        <button
          type="button"
          onClick={this.reset}
          className="px-3 py-1.5 rounded-md border border-surface-600 text-sm text-surface-200 hover:bg-surface-800"
        >
          Try again
        </button>
      </div>
    );
  }
}
